import OBase from './OBase';
import * as Geometry from '../geometry';
import { scaleBooleanInput, rescaleBooleanOutput, rescaleBooleanOutput2 } from '../GHBooleanUtils';

export default class EIntersection extends OBase {
  update () {
    let aTree = this.getSurfaceObjectInput('A');
    let bTree = this.getSurfaceObjectInput('B');

    let output = this.getGenericObjectOutput('surface');

    let outTree = new Geometry.DataTree();
    for (let i = 0, n = aTree.branches.length; i < n; i++) {
      for (let j = 0, m = aTree.branches[i].length; j < m; j++) {
        let a = aTree.branches[i][j];
        var bList = bTree.branches[Math.min(i, bTree.branches.length - 1)];

        a = scaleBooleanInput(a);
        bList = scaleBooleanInput(bList);

        let clipper = new ClipperLib.Clipper();
        clipper.AddPaths(a, ClipperLib.PolyType.ptSubject, true);
        for (let t = 0; t < bList.length; t++) {
          clipper.AddPaths(bList[t], ClipperLib.PolyType.ptClip, true);
        }

        // let solution = new ClipperLib.Paths()
        // clipper.Execute(ClipperLib.ClipType.ctIntersection, solution, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero)
        let solution2 = new ClipperLib.PolyTree();
        clipper.Execute(ClipperLib.ClipType.ctIntersection, solution2, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        let newSolutions = [];
        let polys = solution2.m_Childs;
        for (let i = 0; i < polys.length; i++) {
          let poly = polys[i];
          EIntersection.recursiveSolution(poly, newSolutions);
        }
        let solutions = rescaleBooleanOutput2(newSolutions);

        for (let t = 0; t < solutions.length; t++) {
          outTree.add(solutions[t], aTree.paths[i]);
        }
      }
    }

    output.value = outTree;
  }

  static recursiveSolution (poly, newSolutions) {
    if (poly.IsOpen === false) {
      let newSolution = [];
      let childs = poly.m_Childs;
      newSolution.push(poly.m_polygon);
      for (let j = 0; j < childs.length; j++) {
        let child = childs[j];
        if (child.IsOpen === false) {
          if (child.IsHole()) {
            newSolution.push(child.m_polygon);

            for (let k = 0; k < child.m_Childs.length; k++) {
              this.recursiveSolution(child.m_Childs[k], newSolutions);
            }
          }
        }
      }
      newSolutions.push(newSolution);
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EIntersection.js